// import React, { useRef, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import client1 from "../../assets/Images/2.jpeg";
// import client2 from "../../assets/Images/anoop.jpeg";
// import client3 from "../../assets/Images/srisha.jpeg";
// import client4 from "../../assets/Images/tourist1.jpg";
// import client5 from "../../assets/Images/Magnetic-hill-Ladakh-Places-to-Visit-in-Ladakh-1000x800.jpg.jpg";
// import "./ClientSays.css";


// const clients = [
//   {
//     img: client1,
//     testimonial: "An unforgettable journey, stunning views, luxurious stays, and amazing guidance throughout! Adventure wrapped in pure bliss!",
//   },
//   {
//     img: client2,
//     testimonial: "Great experience-friendly guide, comfy stay, and breathtaking scenery! Feel free, ride the wild.",
//   },
//   {
//     img: client3,
//     testimonial: "Smooth rides, great stays—CK and Tonwang handled everything perfectly. Care, culture, and flawless journeys.",
//   },
//   {
//     img: client4,
//     testimonial: "A wonderful experience with great support.",
//   },
//   {
//     img: client5,
//     testimonial: "Perfectly organized trip, very satisfying!",
//   },
// ];


// const ClientSays = () => {
//   const sliderRef = useRef(null);

//   useEffect(() => {
//     const slider = sliderRef.current;
//     let scrollAmount = 0;

//     const interval = setInterval(() => {
//       const slideWidth = 320; // Approx width of one slide including margin
//       if (slider) {
//         slider.scrollLeft += slideWidth;
//         scrollAmount += slideWidth;

//         // Reset halfway (because content is duplicated)
//         if (scrollAmount >= slider.scrollWidth / 2) {
//           slider.scrollLeft = 0;
//           scrollAmount = 0;
//         }
//       }
//     }, 5000);

//     return () => clearInterval(interval);
//   }, []);

//   const navigate = useNavigate();

// const contact = () => {
//   navigate("/contact-us");
// }


//   return (
//     <div className="container-fluid pt-5">
//       <div className="row mb-4 justify-content-center">
//         <div className="col-lg-6 d-flex flex-column align-items-start justify-content-center ps-5">
//           <button
//             style={{
//               borderRadius: "10px",
//               backgroundColor: "white",
//               width: "fit-content",
//             }}
//           >
//             Testimonials
//           </button>
//           <h3
//             className="mt-3"
//             style={{
//               fontFamily: "Inter",
//               fontWeight: 700,
//               fontSize: "42px",
//               lineHeight: "100%",
//               letterSpacing: "0%",
//             }}
//           >
//             Reliable service and passionate guides bring Ladakh’s wonders to life.
//           </h3>
//         </div>
//         <div className="col-lg-6 d-flex flex-column align-items-start ps-4 pt-3 mt-5">
//           <p
//             style={{
//               fontFamily: "Inter",
//               fontWeight: 400,
//               fontSize: "14px",
//               lineHeight: "100%",
//               letterSpacing: "0%",
//             }}
//           >
//             Travel through Ladakh’s wild beauty and cultural heritage with comfort, safety, and expert guidance every step.
//           </p>
//           <button onClick={contact} style={{ borderRadius: "20px", backgroundColor: "white", padding: "10px 20px" }}>
//             Get Started 
//           </button>
//         </div>
//       </div>

//       <div className="image-slider" ref={sliderRef}>
//   {[...clients, ...clients].map((client, index) => (
//     <div className="slide-img position-relative" key={index}>
//       <img src={client.img} alt={`Client ${index + 1}`} />
//       <div className="glass-overlay-text">
//         <div className="d-flex align-items-center gap-2">
//           <div className="avatar-placeholder"></div>
//           <p className="m-0">
//             {client.testimonial.split(' ').length > 6
//               ? client.testimonial.split(' ').slice(0, 4).join(' ') + '...'
//               : client.testimonial}
//           </p>
//         </div>
//       </div>
//     </div>
//   ))}
// </div>

//     </div>
//   );
// };

// export default ClientSays;





import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import client1 from "../../assets/Images/2.jpeg";
import client2 from "../../assets/Images/anoop.jpeg";
import client3 from "../../assets/Images/srisha.jpeg";
import client4 from "../../assets/Images/tourist1.jpg";
import client5 from "../../assets/Images/Magnetic-hill-Ladakh-Places-to-Visit-in-Ladakh-1000x800.jpg.jpg";
import "./ClientSays.css";

const clients = [
  {
    img: client1,
    testimonial:
      "An unforgettable journey, stunning views, luxurious stays, and amazing guidance throughout! Adventure wrapped in pure bliss!",
  },
  {
    img: client2,
    testimonial:
      "Great experience-friendly guide, comfy stay, and breathtaking scenery! Feel free, ride the wild.",
  },
  {
    img: client3,
    testimonial:
      "Smooth rides, great stays—CK and Tonwang handled everything perfectly. Care, culture, and flawless journeys.",
  },
  {
    img: client4,
    testimonial: "A wonderful experience with great support.",
  },
  {
    img: client5,
    testimonial: "Perfectly organized trip, very satisfying!",
  },
];

const ClientSays = () => {
  const carouselRef = useRef(null);
  const navigate = useNavigate();

  // Responsive settings for carousel
  const responsive = {
    // Extra extra large devices (≥1400px)
    xxl: {
      breakpoint: { max: 4000, min: 1400 },
      items: 4,
    },
    // Extra large devices (≥1200px and <1400px)
    xl: {
      breakpoint: { max: 1399.98, min: 1200 },
      items: 3,
    },
    // Large devices (≥992px and <1200px)
    lg: {
      breakpoint: { max: 1199.98, min: 992 },
      items: 2.4,
    },
    // Medium devices / Tablets (≥768px and <992px)
    md: {
      breakpoint: { max: 991.98, min: 768 },
      items: 2.5,
    },
    // Small devices (≥576px and <768px)
    sm: {
      breakpoint: { max: 767.98, min: 576 },
      items: 1.8,
    },
    // Extra small devices (<576px)
    xs: {
      breakpoint: { max: 575.98, min: 0 },
      items: 1,
    },
  };

  // Navigation handlers
  const handlePrevious = () => {
    carouselRef.current?.previous();
  };

  const handleNext = () => {
    carouselRef.current?.next();
  };

  const contact = () => {
    navigate("/contact-us");
  };

  return (
    <div className="container-fluid pt-5">
      <div className="row mb-4 justify-content-center">
        <div className="col-lg-6 d-flex flex-column align-items-start justify-content-center ps-5">
          <button
            style={{
              borderRadius: "10px",
              backgroundColor: "white",
              width: "fit-content",
            }}
          >
            Testimonials
          </button>
          <h3
            className="mt-3"
            style={{
              fontFamily: "Inter",
              fontWeight: 700,
              fontSize: "42px",
              lineHeight: "100%",
              letterSpacing: "0%",
            }}
          >
            Reliable service and passionate guides bring Ladakh's wonders to
            life.
          </h3>
        </div>
        <div className="col-lg-6 d-flex flex-column align-items-start ps-4 pt-3 mt-5">
          <p
            style={{
              fontFamily: "Inter",
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "100%",
              letterSpacing: "0%",
            }}
          >
            Travel through Ladakh's wild beauty and cultural heritage with
            comfort, safety, and expert guidance every step.
          </p>
          <button
            onClick={contact}
            style={{
              borderRadius: "20px",
              backgroundColor: "white",
              padding: "10px 20px",
            }}
          >
            Get Started
          </button>
        </div>
      </div>

      {/* Carousel Container with Navigation */}
      <div className="client-carousel-wrapper position-relative">
        {/* Previous Button */}
        <button
          onClick={handlePrevious}
          className="client-nav-btn client-prev-btn"
          aria-label="Previous slide"
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>

        {/* Next Button */}
        <button
          onClick={handleNext}
          className="client-nav-btn client-next-btn"
          aria-label="Next slide"
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </button>

        <Carousel
          responsive={responsive}
          ref={carouselRef}
          arrows={false}
          draggable={true}
          swipeable={true}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={5000}
          pauseOnHover={true}
          className="client-carousel"
        >
          {clients.map((client, index) => (
            <div className="slide-img position-relative mx-2" key={index}>
              <img src={client.img} alt={`Client ${index + 1}`} />
              <div className="glass-overlay-text">
                <div className="d-flex align-items-center gap-2">
                  <div className="avatar-placeholder"></div>
                  <p className="m-0">
                    {client.testimonial.split(" ").length > 6
                      ? client.testimonial.split(" ").slice(0, 4).join(" ") +
                        "..."
                      : client.testimonial}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default ClientSays;